// extracted by mini-css-extract-plugin
export default {"button":"BVS0M"};